var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3C10.6112 3 3 10.6112 3 20C3 29.3884 10.6112 37 20 37C29.3884 37 37 29.3884 37 20C37 10.6112 29.3884 3 20 3ZM35.7536 19.968C35.7536 20.9996 35.6526 22.008 35.4622 22.9849L20.8038 19.4948L24.3449 4.84824C30.9239 6.72742 35.7536 12.794 35.7536 19.968ZM20.0316 4.2461C21.0822 4.2461 22.109 4.35082 23.1025 4.54836L19.6947 18.6444L9.95912 7.90688C12.6893 5.6231 16.2025 4.2461 20.0316 4.2461ZM20.0316 35.6896C11.3626 35.6896 4.31002 28.637 4.31002 19.9677C4.31002 15.5868 6.11202 11.6193 9.01256 8.76572L19.6913 20.544L35.1664 24.2282C33.3049 30.8338 27.225 35.6896 20.0316 35.6896Z",
    fill: "#2686df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.788ca9c70fe553aa9656a5f1566485ab.svg";
export { ForwardRef as ReactComponent };